import * as React from 'react';
import { useDrop } from 'react-dnd';

import { StyledDragScroller } from './styles';
import { DndItemTypes } from '../../../typings/dnd';

export enum DragScrollerPosition {
	top = 'top',
	bottom = 'bottom',
}

interface DragScrollerProps {
	position: DragScrollerPosition;
	container: HTMLElement;
}

let scrollingInterval: NodeJS.Timer;

const DragScroller = ({ position, container }: DragScrollerProps) => {
	const [{ isOver }, drop] = useDrop({
		accept: DndItemTypes.DRIVE_ITEM,
		collect: monitor => ({
			isOver: !!monitor.isOver(),
		}),
	});

	React.useEffect(() => {
		if (isOver) {
			const PIXELS_TO_SCROLL = 20;

			scrollingInterval = global.setInterval(() => {
				const { scrollTop, scrollHeight, clientHeight } = container;
				const isTopEdge = position === DragScrollerPosition.top && scrollTop === 0;
				const isBottomEdge = position === DragScrollerPosition.bottom && scrollHeight - scrollTop === clientHeight;

				if (isTopEdge || isBottomEdge) {
					clearInterval(scrollingInterval);
				}

				container.scrollTop += position === DragScrollerPosition.top
					? -PIXELS_TO_SCROLL
					: PIXELS_TO_SCROLL;
			}, 10);
		} else {
			clearInterval(scrollingInterval);
		}
	}, [isOver]);

	return (
		<StyledDragScroller
			ref={drop}
			isTop={position === DragScrollerPosition.top}
		/>
	);
};

export default DragScroller;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/DriveItemList/DragScroller/index.tsx